import { raygun } from '@ynap/clientside-monitoring';

const sendErrorToRaygun = (storageType, method, itemKey, error) => {
    raygun.helpers.agent('send', {
        error: new Error(`error ${storageType}: ${error}`),
        tags: [`error-${storageType}-${method}-${itemKey}`, `${error}`]
    });
};

const setItemOnWebStorage = (storageType, itemKey, itemValue) => {
    try {
        window[storageType].setItem(itemKey, itemValue);
    } catch (error) {
        sendErrorToRaygun(storageType, 'setItem', itemKey, error);
    }
};

const getItemFromWebStorage = (storageType, itemKey) => {
    try {
        return window[storageType].getItem(itemKey);
    } catch (error) {
        sendErrorToRaygun(storageType, 'getItem', itemKey, error);
    }
};

const removeItemFromWebStorage = (storageType, itemKey) => {
    try {
        window[storageType].removeItem(itemKey);
    } catch (error) {
        sendErrorToRaygun(storageType, 'removeItem', itemKey, error);
    }
};

export { setItemOnWebStorage, getItemFromWebStorage, removeItemFromWebStorage };
